import { Injectable } from '@angular/core';
import { FilterForProduct } from './../data-source/product-data-source';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProductDto, ProductServiceProxy, ExcelPagedResultDtoOfCustomerExcelDto, ExcelPagedResultDtoOfProductExcelDto, ProductExcelDto } from './../../../../../../shared/service-proxies/service-proxies';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

	//Kullanıcının herhangi bir depoya yetkisi varmı die kontrol ediyoruz.
	isCheckWarehouse = new BehaviorSubject<boolean>(false);



  filterParams : FilterForProduct = new FilterForProduct();

  warehouseHasPermissionfromRequestAuth : boolean = false;
  products$ = new BehaviorSubject<ProductDto[]>([]);
  productsForExcel$ : BehaviorSubject<ExcelPagedResultDtoOfProductExcelDto> = new BehaviorSubject<ExcelPagedResultDtoOfProductExcelDto>(null);
  totalCount$ = new BehaviorSubject<number>(0);
  loading$ = new BehaviorSubject<boolean>(false);
  resetPageNumber$ = new BehaviorSubject<boolean>(false);
  isNoRecord$ = new BehaviorSubject<boolean>(false);



  isTest : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


 
  constructor(private _productService : ProductServiceProxy) { 

  }

  loadProductList() {
    // const filter = this.filterParams ;
     //this.dataSource.loadData(this.filterParams);
     this.loading$.next(true);
     this.isNoRecord$.next(false);
   
     console.log("Urunler alinacak, filter params su durumda!");
     console.log(this.filterParams);
   
     const skipCount = this.filterParams.pageIndex * (this.filterParams.maxResultCount ? this.filterParams.maxResultCount : 0);

	  this._productService.getWarehousesProductStockListByUserAuths(
		  this.filterParams.brands,
		  this.filterParams.productTypes,
		  this.filterParams.businessUnits,
		  this.filterParams.warehouses,
		  this.filterParams.keyword, 
		   this.filterParams.sorting, 
             skipCount,
             this.filterParams.maxResultCount,
       )
     .subscribe(
         products => 
         {

           this.products$.next(products.items)
           this.totalCount$.next(products.totalCount);
           this.resetPageNumber$.next(false);

           this.isNoRecord$.next(products.totalCount == 0);
   
           console.log('Gelen urunler....');
            console.log(products.items);
          
            

             //this.hasItemsSubject.next(products.items.length > 0);
   
         },
   
         (err) => {}, //Error
         () => {      //OnComplete
            // this.loadingSubject.next(false);
            this.loading$.next(false);
         }
     )
  }

  loadDataForExcel() {
    this._productService.getAllForExcel('', '', 0, 50)
      .subscribe(products1 => {
        console.log('Iste benim datam !');
        console.log(products1);
        this.productsForExcel$.next(products1);
      });
  }

  resetService() : void {
    this.filterParams = new FilterForProduct();

  this.products$.next([]);
  this.totalCount$.next(0);
  this.loading$.next(false);
  this.resetPageNumber$.next(true);
  }

}
